export { default } from '@/components/pages/LoginPage';

export { getServerSideProps } from '@/components/pages/LoginPage/gssp';
